import Vue from 'vue';
import {request} from "./requests";
import {Entity, User, Deal} from "./converter";
import {vue} from "../main";
import {DateFormat, User as User_} from "../utils";

/**
 *
 * @param email
 * @param username
 * @param password
 * @param inviteCode
 * @return {Promise<Boolean>}
 */
export async function register(email, password, username = null, inviteCode=null) {
    console.log(`try to register with ${email}, ${username}, ${password}, ${inviteCode}`);
    let data = Object();
    data.email = email;
    data.password = password;
    if(username !== null) data.username = username;
    if(inviteCode!==null) data.inviteCode = inviteCode;
    let r = await request({
        url: `/u/reg`,
        data: data,
        method: 'post'
    });
    if(r.success){
        let user = r.data;
        this.$store.commit('setUser', user);
        vue.$EventBus.$emit('signedin'); // send out the global event.
    }
    return r;
}

/**
 * 登录成功以后的 token 的存储逻辑是直接在 requests.js 中的 reponse 拦截处理的。
 * @param accountname, username or email.
 * @param password
 * @return {Promise<Object>}, Object:{success: [true|false], data}
 */
export async function login(accountname, password){
    let r = await request({
        url: `/u/login`,
        data: {
            accountname: accountname,
            password: password
        },
        method: 'post'
    });
    if(r.success){
        let user = r.data;
        vue.$store.commit('setUser', user);
        vue.$EventBus.$emit('signedin'); // send out the global event.
    }
    return r;
}

export async function signout(){
    let data = await request({
        url: `u/signout`,
        method: 'get'
    });
    User_.removeToken(); // 清除 token
    vue.$store.commit('setUser', null); // clean the user
    vue.$EventBus.$emit('signout'); // send out the global event.
    return data;
}

/**
 * to check if the client signed in with server.
 * @return {Promise<Boolean>}
 */
export async function isSignedIn(){
    // will auto convert the str boolean value to boolean type.
    let r = await request({
        url: `/u/isi`, // isi: is signed in
        method: 'get',
        retriable: true
    });
    // console.log('is signed in return', JSON.stringify(r, null, 4));
    if(r.isSignedIn) this.$store.commit('setUser', r.data);
    return r.isSignedIn;
}

/**
 * 获取匿名用户，返回 token。将会被 response interceptor 自动拦截，因此这里无需做任何事情，只是发起请求即可。
 * @return {Promise<void>}
 */
export async function anoms(){
    await request({url: '/u/anoms', retriable: true});
}

/**
 * 同时检查是否存在以及是否合法
 * c->check, vd->valid
 * @param username
 * @return {Promise<{pass:boolean, error:{undefined|String}}>}
 */
export async function isUsernameValid(username){
    let r = await request({
        url: `/u/cvd/username/${username}`,
        method: 'get'
    });
    console.log(`check username ${username} is valid remotely and respond with ${r}`);
    return r;
}

/**
 * 同时检查是否存在以及是否合法
 * c->check, vd->valid
 * @param email
 * @return {Promise<{pass:boolean, error:{undefined|String}}>}
 */
export async function isEmailExists(email){
    let isExists = await request({
        url: `/u/exists/email/${email}`,
        method: 'get'
    });
    console.log(`is email ${email} exists ${isExists}`);
    return isExists;
}

/** =================== 下面是 User Center 的相关请求 =================== **/

/**
 * not only load the user by also sync the user into $store.
 * @return {Promise<void>}
 */
export async function loadUser(){
    let user = await request({
        url: `/u/center/userinfo/`,
        method: 'get'
    })
    this.$store.commit("setUser", user);
    return User.convertUser(user);
}

/**
 * likes or dislikes the entity, depending on the likes boolean value.
 * @param shortcode, the entity short code
 * @param {boolean} likes, if false, means dislike.
 * @return {Promise<boolean>}
 */
export async function likes(shortcode, likes){
    try{
        await request({
            url: `/u/center/likes/e`,
            data: {
                shortcode: shortcode,
                likes: likes
            },
            method: 'post'
        });
    }catch(err){
        console.log('likes error:', err);
        throw err;
    }
}

/**
 * favorites or disfavorites the entity, depending on the likes boolean value.
 * @param shortcode, the entity short code
 * @param {boolean} favorites, if false, means disfavorites.
 * @return {Promise<boolean>}
 */
export async function favorites(shortcode, favorites){
    try{
        await request({
            url: `/u/center/favorites/e`,
            data: {
                shortcode: shortcode,
                favorites: favorites
            },
            method: 'post'
        });
    }catch(err){
        console.log('likes error:', err);
        throw err;
    }
}

/**
 * favorites or disfavorites the profile, depending on the follows_ boolean value.
 * @param {String} code, the profile code
 * @param {boolean} follows, if false, means disfollows.
 * @return {Promise<boolean>}
 */
export async function follows(code, follows){
    try{
        await request({
            url: `/u/center/follows/p`,
            data: {
                code: code,
                follows: follows
            },
            method: 'post'
        });
    }catch(err){
        console.log('follows_ error:', err);
        throw err;
    }
}

/**
 * 获取当前新用户注册所能奖励的积分，在首页初始化的时候就展示，并且应用到 Slogans 当中
 * @return {Promise<SVGPointList>}
 * @deprecated by getConfs.
 */
export async function loadNewUserRewardPoint(){
    try{
        let r = await request({
            url: `/u/newUserRewardPoints`,
            method: 'get'
        });
        let points = r.points
        vue.$store.commit('setNewUserRewardPoints', points)
        return points;
    }catch(err){
        console.log(err);
        throw err;
    }
}

/**
 * 检查该登录用户的邮箱是否已经激活？
 * @return {Promise<AxiosResponse<*>>}
 */
export async function isEmailActivated(){
    let isActivated = await request({
        url: `/u/center/iea`,
        method: 'get',
        retriable: true
    });
    return isActivated;
}

/**
 * 向用户的邮箱发送邮箱激活码
 * @return {Promise<void>}
 */
export async function sendEmailActivateCode(){
    await request({
        url: `/u/center/saec`,
        method: 'get'
    })
}

/**
 * 验证邮箱激活码是否有效
 * @param activateCode
 * @return {Promise<void>}
 */
export async function verifyEmailActivaiteCode(activateCode){
    var r = await request({
        url: `/u/center/vaec`,
        data: {
            code: activateCode
        },
        method: 'post'
    })
    return r;
}

export async function activateEmail(activateCode){
    var user = await request({
        url: '/u/center/email/activate',
        data: {
            code: activateCode
        },
        method: 'post'
    });
    this.$store.commit('setUser', user);
    return user;
}

export async function loadInviteCode(){
    let user = this.$store.state.user;
    if(user.inviteCode === undefined || user.inviteCode === null){
        var inviteCode = await request({
            url: '/u/center/invitecode',
            method: 'get',
            retriable: true
        });
        console.log(`invite code retrieved as ${JSON.stringify(inviteCode, null , 4)}`);
        inviteCode.valid_to = DateFormat.yYMmDdFormat(inviteCode.valid_to);
        user.inviteCode = inviteCode; // 注意：将 inviteCode 赋值给了 user 对象
        this.$store.commit('setUser', user);
    }
    return user.inviteCode;
}

export async function loadInviteCodeTrace(pageNum){
    var traces = await request({
        url: '/u/center/invitecode/trace',
        data: {
            pageNum: pageNum
        },
        method: 'post'
    });
    console.log('invite code traces loaded:', traces);
    return traces;
}

// 获取邀请人通过邀请码获得的奖励积分总数
export async function getInviteCodeTraceTotal(){
    var total = await request({
        url: '/u/center/invitecode/trace/total',
        method: 'get'
    });
    console.log('invite code traces total:', total);
    return total;
}

/**
 * 检查密码是否正确，便于用户重置密码。
 * c-> check, pw -> password
 * @return {Promise<void>}
 */
export async function checkPassword(password){
    var isValid = await request({
        url: '/u/center/cpw',
        data: {
            password: password
        },
        method: 'post'
    })
    return isValid
}

/**
 * 注意，虽然前段验证通过，后端接口依然需要验证 oldPassword，避免漏洞！
 * cg-> change, pw -> password
 * @param oldPassword
 * @param password
 * @return {Promise<void>}
 */
export async function changePassword(oldPassword, password){
    await request({
        url: '/u/center/cgpw',
        data: {
            oldPassword: oldPassword,
            password: password, // the new password
        },
        method: 'post'
    });
}

export async function changeUsername(username){
    await request({
        url: '/u/center/cgun',
        data: {
            username: username
        },
        method: 'post'
    })
}

/**
 *
 * @param _id
 * @param type, 取值 entity 或者 thread.
 * @param tipoffCode
 * @param tipoffContent
 * @return {Promise<void>}
 */
export async function sendTipoffs(_id, type, tipoffCode, tipoffContent=null) {
    await request({
        url: '/u/center/tipoff',
        data: {
            id: _id,
            type: type,
            tipoffCode: tipoffCode,
            tipoffContent: tipoffContent
        },
        method: 'post'
    });
}

export async function blackIt(type, code){
    await request({
        url: '/u/center/blacklist/save',
        data: {
            type: type,
            code: code
        },
        method: 'post'
    });
}

/**
 * call backend to send the email to reset the password
 * f-> find, pw->password.
 * @param email
 * @return {Promise<void>}
 */
export async function findPassword(email){
    await request({
        url: '/u/fpw',
        data: {
            email: email
        },
        method: 'post'
    })
}

/**
 * 检查重置密码校验码是否有效
 * @param shortcode
 * @return {Promise<void>}
 */
export async function verifyResetPasswordCode(shortcode){
    let pass = await request({
        url: '/u/rstpwd/chk',
        data: {
            shortcode: shortcode
        },
        method: 'post'
    });
    return pass;
}

/**
 * 与 changePassword 方法不同，这里是通过忘记密码通道进入的，因此需要 shortcode 校验码
 * @param shortcode，校验码
 * @param password
 * @return {Promise<void>}
 */
export async function resetPassword(shortcode, password){
    await request({
        url: '/u/rstpwd',
        data: {
            shortcode: shortcode,
            password: password
        },
        method: 'post'
    })
}

export async function loadDeals(pageNum){
    let deals = await request({
        url: '/u/deals',
        data: {pageNum: pageNum},
        method: 'post',
        retriable: true
    });
    return Deal.convertDeals(deals);
}

/**
 * 注意，返回的是 Entities -> 为了重用 List 组件，List 组件接收的就是 Entities。
 * @param pageNum
 * @return {Promise<Array>}
 */
export async function loadViewHis(pageNum){
    let page = await request({
        url: '/u/viewhis',
        data: {pageNum: pageNum},
        method: 'post',
        retriable: true
    });
    return Entity.convertEntities(page);
}





// WEBPACK FOOTER //
// ./src/data/user.js